import React from 'react'
import {
    Heading, Button, Flex,
    Spinner, Th, Thead, Tr, Td, Table, Tbody, Box
} from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import { FaUsers } from 'react-icons/fa';
import EmptyStateCard from '../../compnents/EmptyStateCard';

function SettingsCustomerListPaid({ customers, loadingCustomers }) {
    const navigate = useNavigate();
    return (
        <>
            <Flex justify="space-between" align="center" mt={4}>
                <Heading size="md">Customer List</Heading>
                <Button colorScheme="purple" onClick={() => navigate('/settings/manageCustomers')}>
                    Manage Customers
                </Button>
            </Flex>

            {loadingCustomers ? (
                <Spinner color="purple.400" alignSelf="center" />
            ) : customers.length > 0 ? (
                <Table variant="striped" colorScheme="purple" size="md">
                    <Thead>
                        <Tr>
                            <Th>Customer ID</Th>
                            <Th>Country</Th>
                            <Th>Age</Th>
                            <Th>Risk Profile</Th>
                            <Th>Created At</Th>
                        </Tr>
                    </Thead>
                    <Tbody>
                        {customers.map((cust) => (
                            <Tr key={cust.customer_id}>
                                <Td>{cust.customer_id}</Td>
                                <Td>{cust.country_iso}</Td>
                                <Td>{cust.age}</Td>
                                <Td>{cust.risk_profile}</Td>
                                <Td>{new Date(cust.created_at).toLocaleDateString()}</Td>
                            </Tr>
                        ))}

                        {customers.length >= 7 && (
                            <Tr>
                                <Td colSpan={5} textAlign="center" color="gray.500" fontWeight="bold">
                                    ...
                                </Td>
                            </Tr>
                        )}
                    </Tbody>
                </Table>
            ) : (
                <Box py={4}>
                    <EmptyStateCard
                        icon={FaUsers}
                        title="No customers available yet"
                        description="Customer records will appear here after the latest dataset has been processed and synced into the workspace."
                        hint="If you recently uploaded a file, give the job a moment. Otherwise, open customer management to review the source data."
                        borderColor="purple.100"
                        titleColor="gray.700"
                        descriptionColor="gray.600"
                        hintColor="gray.500"
                        iconColor="purple.500"
                        maxW="full"
                    >
                        <Button colorScheme="purple" onClick={() => navigate('/settings/manageCustomers')}>
                            Manage Customers
                        </Button>
                    </EmptyStateCard>
                </Box>
            )}
        </>
    )
}

export default SettingsCustomerListPaid
